// extracted by mini-css-extract-plugin
export var productImage = "_zp-0";